<div class="centru">
    <ngc-data-error [errorMessage]="PAGE_NOT_FOUND_MESSAGE"></ngc-data-error>
</div>
